export default function initPageEdge(){
	//this is for the rounded corner element that overlaps the previous section. As it can be applied to any section we need to get and apply the background color at runtime
	document.querySelectorAll('.is_page_edge').forEach(el => {
		const bgColor = getComputedStyle(el).backgroundColor;
		el.style.setProperty('--page-edge-bg-color', bgColor);
	});
}
